const Header = (target: Element) => {
  const toggleMenuBtn = target.querySelector('.header__toggle-menu')
  const allNavItemsWithSub = target.querySelectorAll('.nav__item--has-sub')
  const backButtons = target.querySelectorAll('.nav__item--back')
  const htmlTag = document.querySelector('html')

  const method = {
    init: () => {
      toggleMenuBtn.addEventListener('click', method.onToggleClick)
      allNavItemsWithSub.forEach((n: HTMLElement) => {
        const x = n.querySelectorAll('a')
        const aList = Array.prototype.slice
          .call(x)
          .filter((j: Node) => j.parentElement.classList.contains('nav__item--has-sub'))

        aList.forEach((a: HTMLElement) => {
          a.addEventListener('click', (e) => method.clickA(e, a))
        })
      })
      backButtons.forEach((b) => {
        b.addEventListener('click', (e) => method.clickA(e, b))
      })
      window.addEventListener('resize', method.resize)
    },
    resize: () => {
      const windowW = window.innerWidth
      if (windowW > 1125) {
        method.doClose()
        method.allowScroll()
      }
    },
    allowScroll: () => {
      document.body.classList.remove('no-scroll')
      htmlTag.classList.remove('no-scroll')
    },
    blockScroll: () => {
      document.body.classList.add('no-scroll')
      htmlTag.classList.add('no-scroll')
    },
    clickA: (e, a) => {
      const windowW = window.innerWidth

      const parent = a.parentElement
      const closestNav = a.closest('.nav__sub--active')

      if (parent.classList.contains('nav__item--has-sub') || closestNav) {
        if (closestNav && closestNav.classList.contains('nav__sub--active')) {
          setTimeout(() => {
            closestNav.classList.remove('nav__sub--active')
          }, 300)
        } else {
          parent.classList.add('nav__sub--active')
        }
      }

      if (windowW < 993) {
        e.preventDefault()

        if (target.classList.contains('header--subnav')) {
          target.classList.remove('header--subnav')
        } else {
          target.classList.add('header--subnav')
        }
      }
    },
    onToggleClick: (e) => {
      e.preventDefault()

      const isOpen = target.classList.contains('header--open')
      if (isOpen) {
        method.doClose()
        method.allowScroll()
      } else {
        method.doOpen()
        method.blockScroll()
      }
    },
    doOpen: () => {
      toggleMenuBtn.classList.add('header__toggle-menu--open')
      target.classList.add('header--preopen')

      setTimeout(() => {
        target.classList.add('header--open')
      }, 0)
    },
    doClose: () => {
      toggleMenuBtn.classList.remove('header__toggle-menu--open')
      target.classList.remove('header--open')
      target.classList.remove('header--subnav')

      setTimeout(() => {
        target.classList.remove('header--preopen')
      }, 200)
    },
  }

  method.init()
}

export default Header
